import { newDiv, prepareEvent } from '../RenderUtils';
import { addAnalyticsAttribute } from '../../../helpers/analytics';
import { CONTROLS_EVENTS_GA } from './Constants';
import { LOCALES } from './Locales';
import { checkIsValidCurrentValue, checkIsValidVariants } from './checkIsValid';

const MOVEMODES_OPTIONS = {
  WALK: 'Walk',
  ORBIT: 'Orbit',
  FLY: 'Fly',
};

const OPTION_CONFIG = {
  [MOVEMODES_OPTIONS.WALK]: {
    image: {
      default: '/images/map/walk.svg',
      active: '/images/map/walk_active.svg',
    },
    content: LOCALES.MOVEMODES_WALK[window.currentLanguage],
  },
  [MOVEMODES_OPTIONS.ORBIT]: {
    image: {
      default: '/images/map/orbit.svg',
      active: '/images/map/orbit_active.svg',
    },
    content: LOCALES.MOVEMODES_ORBIT[window.currentLanguage],
  },
};

const MOVE_MODE_TO_GA_EVENT = {
  [MOVEMODES_OPTIONS.WALK]: CONTROLS_EVENTS_GA.MOVEMODES_WALK,
  [MOVEMODES_OPTIONS.ORBIT]: CONTROLS_EVENTS_GA.MOVEMODES_ORBIT,
  [MOVEMODES_OPTIONS.FLY]: CONTROLS_EVENTS_GA.MOVEMODES_FLY,
};

export class MovemodesControl {
  static isConfigurationValid = ({ current, variants }) => {
    const expectedVariants = Object.values(MOVEMODES_OPTIONS);
    const isValidCurrentValue = checkIsValidCurrentValue({
      current,
      expectedVariants,
      name: 'movemode',
    });
    const isValidVariants = checkIsValidVariants({ variants, expectedVariants, name: 'movemode' });

    return isValidCurrentValue && isValidVariants;
  };

  constructor(container, parentIframe, controlSetup, currentMoveMode) {
    this.container = container;
    this.parentIframe = parentIframe;
    this.controlSetup = controlSetup;
    this.currentMoveMode = currentMoveMode;
    this.movemodeEnabled = true;
    this.currentElement = null;
  }

  updateCurrentMoveMode(mode) {
    this.currentMoveMode = mode;
  }

  updateControlSetup(setup) {
    this.controlSetup = setup;
  }

  updateCurrentElement(element) {
    this.currentElement = element;
  }

  updateMovemodeEnabled(mode) {
    this.movemodeEnabled = mode;
  }

  render() {
    const moveModeElement = newDiv(null, this.container);
    moveModeElement.classList.add('MovemodesControl');

    this.controlSetup = this.controlSetup.map((moveMode) => {
      const element = newDiv(null, moveModeElement);
      element.classList.add('Option');

      addAnalyticsAttribute(element, MOVE_MODE_TO_GA_EVENT[moveMode.name]);

      if (moveMode.name === MOVEMODES_OPTIONS.FLY) {
        element.classList.add('hidden');
        return {
          name: moveMode.name,
        };
      }

      const image = document.createElement('img');
      image.classList.add('Option-image');
      const content = document.createElement('div');
      content.classList.add('Option-content');

      image.src = OPTION_CONFIG[moveMode.name].image.default;
      content.innerText = OPTION_CONFIG[moveMode.name].content;

      element.appendChild(image);
      element.appendChild(content);

      const updateImageSrc = (optionNode, optionName, type) => {
        const nodeImage = optionNode.querySelector('img');
        nodeImage.src = OPTION_CONFIG[optionName].image[type];
      };

      if (moveMode.name === this.currentMoveMode) {
        element.classList.add('-active');
        updateImageSrc(element, moveMode.name, 'active');
        this.updateCurrentElement(element);
      }

      const activate = () => {
        if (moveMode.name !== this.currentMoveMode) {
          this.currentElement.classList.remove('-active');
          updateImageSrc(this.currentElement, this.currentMoveMode, 'default');

          this.updateCurrentMoveMode(moveMode.name);
          this.updateCurrentElement(element);

          this.currentElement.classList.add('-active');
          updateImageSrc(this.currentElement, moveMode.name, 'active');

          this.parentIframe.postMessage(
            { type: 'buttons', action: 'movemode', name: moveMode.name },
            '*',
          );
        }
      };
      element.addEventListener('click', (e) => {
        prepareEvent(e);
        if (this.movemodeEnabled) {
          activate();
        }
      });

      return {
        name: moveMode.name,
        visible: moveMode.visible,
        element,
        activate,
      };
    });

    if (!this.currentElement) {
      throw new Error('Default move mode is not in move modes list');
    }
  }
}
